var I18n_es  = {
  languages_name : {
    fr : "Francés",
    eu : "Vasco",
    es : "Español",
    en: "Inglés"
  },
  tuto : {
    next: "SIGUIENTE",
    page1_title : "Informaciones",
    page1_subtitle : "Esté mejor informado sobre el estado de la mar y las condiciones meteorológicas locales",
    page1_description : "Color de la bandera, el tiempo, estado de la mar: encuentre aquí todas las informaciones prácticas de las zonas de baño de la Communauté Pays Basque.",
    page2_title : "Su aplicación",
    page2_subtitle : "Personalice la aplicación seleccionando sus playas favoritas",
    page2_description : "Personalice la aplicación seleccionando sus playas favoritas para seguir la evolución de las condiciones de sus zonas de baño",
    page3_title : "Gracias a ellos !",
    page3_subtitle : "Este proyecto ha sido cofinanciado por la Union Europea.",
    page3_description : "Europa se compromete en la región Nouvelle Aquitaine a través del Fondo Europeo de Desarrollo Regional.",
  },
  flag_explanations : {
    explanation_0 : "Playa sin vigilancia",
    explanation_1 : "Baño vigilado y no hay peligro",
    explanation_2 : "Baño peligroso, con peligro limitado o importante",
    explanation_3 : "Prohibido el baño",
    explanation_31 : "Prohibido el baño",
    explanation_32 : "Prohibido el baño\nMalas condiciones meteorológicas",
    explanation_33 : "Prohibido el baño\nBaño peligroso (oleaje, corriente)",
    explanation_34 : "Prohibido el baño\nMedusas",
    explanation_35 : "Prohibido el baño\nContaminación (residuos flotantes, hidrocarburos…)",
    explanation_36 : "Prohibido el baño\nEventos",
    explanation_37 : "Prohibido el baño\nSe está realizando una operación de salvamento ",
    explanation_38 : "Baño prohibido\nAlga Ostreopsis en la zona de baño",
    explanation_4 : "Prohibido el baño\nDegradación momentánea de la calidad del agua",
    explanation_5 : "Baño no vigilado",
    //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
    explanation_6: 'Mirador del oceano',
    //EO TODO
    explanation_null : "",
    conform_quality : "Calidad conforme",
    not_conform_quality : "Calidad no conforme",
    no_quality : "Calidad no especificada",
  },
  //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
  quality_explanations: {
    explanation_1: 'Calidad conforme',
    explanation_3: 'Calidad conforme',
    explanation_2: 'Calidad no conforme',
    explanation_4: 'Calidad no conforme',
    explanation_5: 'Calidad no conforme',
    explanation_0: 'Calidad no especificada',
    explanation_51: 'Fuertes lluvias, tormentas',
    explanation_52: 'Incidencia técnica - red',
    explanation_53: 'Daños que provienen de alta mar',
    explanation_54: 'Penacho rio',
  },
  ostreopsis_explanations : {
    explanation_0: 'Ostreopsis- sin riesgo',
    explanation_1: 'Ostreopsis- riesgo bajo',
    explanation_2: 'Ostreopsis-riesgo  moderado',
    explanation_3: 'Ostreopsis-riesgo  moderado',
    explanation_4: 'Ostreopsis-riesto alto',
  },
  alertform: {
    header_title: 'Alertar',
    type: 'Tipo',
    localization: 'Posición geográfica',
    description: 'Descripción',
    incomplete_desc: 'Descripción incompleta',
    incomplete_desc_text:
      'Defina al menos un tipo y una descripción (o foto)',
    thanks: 'Gracias',
    classify: 'Tipo',
    free_description: 'Descripción libre',
    your_info: 'Vos coordonnées',
    position: 'Posición geográfica',
    photo: 'Foto',
    alert_success_text:
      'Muchas gracias por su notificación - En caso de peligro le rogamos lo notifique a los servicios de urgencias llamando al 18',
    pollution: 'Pollution',
    security: 'Sécurité/Risques',
    echouage: 'Echouage',
    other: 'Autres',
    sea: 'Mer',
    beach: 'Plage',
    dead_animal: 'Animal mort',
    difficulty_animal: 'Animal en difficulté',
    waste: 'Déchets',
    odour: 'Odeur',
    medusa: 'Méduses',
    wood: 'Bois',
    fishing_net: 'Filet',
    hydrocarbon: 'Hydrocarbure',
    turtle: 'Tortue',
    bird: 'Oiseau',
    mammal: 'Mammifère marin',
    theme1: "Vertido de agua sospechosa",
    theme2: 'Animal varado',
    theme3: 'Démangeaisons',
    theme4: 'Hydrocarbures',
    theme5: 'Medusas/Fisálidos',
    theme6: 'Drapeaux',
    theme7: "Aplicación Kalilo",
    theme99: 'Otro',
    localiser: 'Localizar',
    send: 'Enviar',
    validate: 'Validar',
    close: 'Cerrar',
  },
  // EO TODO
  tabs: {
    beaches: 'Playas',
    alerts: "Alertas",
    news: "Info",
    favorites: "Favoritos",
    more: "Parámetros",
    app: "Kalilo",
  },
  news: {
    header_title: "Conviene saber",
    //title: "Bon à savoir",
    //subtitle: "L'agglomération met tout en oeuvre pour vous informer des bons gestes...",
    //show: "Afficher"
  },
  alerts: {
    header_title: "Alertas",
    title: "Alertas",
    subtitle: "La Comunidad del País Vasco se esfuerza en informarle de todo lo que ocurre en el litoral.",
    tell_a_friend: "Prevenir"
  },
  beaches_list: {
    title: "Explorar",
    favorites: "Favoritos",
    search_beach: "Buscar una playa",
    beaches: "playas",
    beach: "playa"
  },
  beaches_filters: {
    page_title: "Filtros",
    page_subtitle: '¿Qué desea usted mostrar ?',
    beaches_title: "Playas",
    beaches_favorites: "Playas favoritas",
    services_title: "Servicios",
    services_subtitle: "Mostrar únicamente los siguentes servicios",
    show: "Mostrar",
    service_1: "Handiplage",
    service_2: "Parking",
    service_3: "Actividades náuticas",
    service_4: "Clubs de actividades",
    service_5: "Baños \n Duchas",
    service_6: "Duchas",
    service_8: "Restaurantes",
    filter_result_1: 'playa responden a sus criterios',
    filter_result_2: ' playas responden a sus criterios'
  },
  beaches_search: {
    title: "Elegir",
    search: "Buscar una playa"
  },
  beach_details : {
    tab_informations: "INFORMACIONES",
    tab_previsions: "EL TIEMPO",
    tab_go: "COMO LLEGAR",
    oversight: "VIGILANCIA",
    phone: "TELEFONO",
    more_info: 'MAS INFORMACION',
    favorites: 'FAVORITOS',
    pavillon_bleu: 'Distinción Bandera azul',
    demarche_qualite: 'Certificación calidad de las aguas de baño',
    updated_on: 'Actualizado el',
    updated_today: 'Actualizado a las',
    updated_at_time: 'a las',
  },
  beaches_favorites : {
    title: "Favoritos",
    beaches: "playas",
    beach: "playa",
    intro: "Vea aquí la lista de sus playas favoritas.",
    no_beach_title: "Todavia no ha elegido sus playas favoritas",
    no_beach_desc: "Añada una o varias playas a sus favoritos para recibir únicamente informaciones de esas playas.",
    add: "Añadir"
  },
  settings : {
    title : "Parámetros",
    choose_language: "Su idioma",
    language: "Idioma elegido",
    choose_notifications: "Activar las notificaciones",
    notifications: "Activar las notificaciones para recibir instantáneamente los cambios que puedan surgir en sus playas favoritas (color de la bandera, …)",
    informations: "Informacion",
    legal_notices: "Aviso legal",
    credits: "Créditos",
    about: "Más información ",
    help: "Ayuda"
  },
  about : {
    page_title: "Más información ",
    description: 'Kalilo es una aplicación que le permite estar informado de las condiciones de baño. Sin embargo, su seguridad depende sobre todo de su comportamiento: debe fiarse de forma prioritaria de las informaciones transmitidas por el puesto de primeros auxilios. Si constatara una diferencia entre el color de la bandera que ondea en la playa y el color que indica la aplicación, debe fiarse de forma prioritaria de la bandera que ondea en la playa.'
  },
  legal_noticies: {
    page_title: "Aviso legal",
    description: `
La aplicación Kalilo ha sido editada por la Communauté d’agglomération Pays Basque

Contacto :
littoral@communaute-paysbasque.fr

Dirección de la comunicación :
communication@communaute-paysbasque.fr
    `,
    description2: `Los datos personales de los internautas que se recogen, se transmiten exclusivamente al editor de la aplicación y se tratan respetando las disposiciones de la ley francesa n°78-17 del 6 enero 1978, llamada Ley Informática y Libertades. El responsable del tratamiento de datos es el editor indicado precedentemente: ningún dato personal es cedido ni comunicado a terceras partes.`
  },
  credits: {
    page_title: "Créditos",
    source_title: 'Fuentes de los datos',
    source_description: '« Informaciones »',
    dev_title: "Desarrollo",
    design_ux_title: 'Diseño UX - Diseño UI :' ,
    design_title: 'Diseño',
    credits_title : 'Créditos fotos'
  },
  settings_language : {
    title : "Su idioma",
    apply_button : "Aplicar",
    question: "¿Qué idioma quiere aplicar?"
  },
  days_name : {
    1 : "Lunes",
    2 : "Martes",
    3 : "Miécoles",
    4 : "Jueves",
    5 : "Viernes",
    6 : "Sábado",
    0 : "Domingo",
  },
  days_subname : {
    0: "Hoy",
    1: "Mañana",
    2: "Pasado mañana"
  },
  creneau : {
    1: "Mañana",
    2: "Mediodía",
    3: "Tarde"
  },
  weather : {
    swell: "Oleaje",
    period: "Periodo",
    direction: "Dirección",
    tides: "Mareas",
    hm: "MAREA ALTA",
    bm : "MAREA BAJA",
    coeff: "COEFICIENTE",
    wind: "Viento",
    water_temp: "agua",
    uv: "UV"
  },
  location : {
    itinerary : "ITINERARIO",
    txiktxak : "TRANSPORTE",
  },
  map: {
    title : "Fuera de la temporada",
    line_1: "¡Manténgase informado sobre el estado del mar y el tiempo en las playas!",
    line_2: "Recordatorio:  el baño no está vigilado y  se practica bajo su propia responsabilidad"
  },
  map_pleine_saison: {
    title : "Siga informado",
  },
  map_hors_saison: {
    title : "Fuera de la temporada",
    line_1: "¡Manténgase informado sobre el estado del mar y el tiempo en las playas!",
    line_2: "Recordatorio:  el baño no está vigilado y  se practica bajo su propia responsabilidad"
  },
  map_all_beaches_closed: {
    title : "Sin vigilancia",
    line_1: "El baño no está vigilado actualmente. Si se baña, lo hace bajo su propia responsabilidad.",
  },
  map_switch: {
    flag: 'Color de las banderas',
    quality: 'Calidad bacteriológica del agua',
    ostreopsis: 'Nivel de alerta Ostreopsis',
  },
};

export default I18n_es;
